import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from "@angular/core";
import {SearchApiObservableService} from "./search-api-observable.service";

@Component({
    selector: 'tfl-filter-container',
    template: `
        <div class="filter-container">
            <div class="row">
                <div class="col-lg-12">
                    <div id="show-hide-container" class="pull-right" (click)="changeVisibility()">
                        <span *ngIf="!visibilityState">{{ 'FILTER.BUTTON.SHOW' | translate }}</span>
                        <span *ngIf="visibilityState">{{ 'FILTER.BUTTON.HIDE' | translate }}</span>
                        <i [ngClass]="visibilityState ? 'fa fa-chevron-up' : 'fa fa-chevron-down'" aria-hidden="true"></i>
                    </div>
                    
                    <form *ngIf="visibilityState" class='filter-form form-horizontal' #f="ngForm" autocomplete="off" novalidate
                          (ngSubmit)="f.valid&&search()">
    
                        <div class="row">
                            <ng-content select="tfl-filter-input"></ng-content>
                        </div>
    
                        <div class="pull-right">
                            <div>
                                <button id="search-button"
                                        class="btn btn-primary"
                                        [disabled]="shouldDisableSearchButton||!f.valid">
                                    {{ 'FILTER.BUTTON.SEARCH' | translate }}
                                </button>
                                <button type="reset"
                                        id="reset-button"
                                        class="btn btn-default"
                                        [disabled]="shouldDisableResetButton"
                                        (click)="resetFilter()">
                                    {{ 'FILTER.BUTTON.RESET' | translate }}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    `,
    styles: [`
        #search-button, #reset-button {
            margin: 10px 0 10px 10px;
            width: 100px;
        }

        #show-hide-container {
            cursor: pointer;
        }
        
        .filter-container {
            margin-bottom: 20px;
        }

        .filter-form {
            margin-top: 30px;
        }
    `]
})
export class FilterContainerComponent {

    @Input() callUrl: string;
    @Input() filterModel: FilterModel;
    @Input() shouldDisableSearchButton: boolean = false;
    @Input() shouldDisableResetButton: boolean = false;
    @Output() onSearch: EventEmitter<any> = new EventEmitter();
    @Output() onReset: EventEmitter<FilterModel> = new EventEmitter();

    visibilityState: boolean = true;

    constructor(private _filteringProvider: SearchApiObservableService) {
    }

    changeVisibility() {
        this.visibilityState = !this.visibilityState;
    }

    search() {
        this._filteringProvider
            .searchRequestForUrl(this.callUrl, this.filterModel)
            .subscribe(jsonResponse => this.onSearch.emit(jsonResponse));
    }

    resetFilter() {
        this.onReset.emit();
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/filter/filter-container.component.ts